import React, { useContext, useEffect, useState } from 'react';
import { Calendar } from '@carbon/icons-react';
import classNames from 'classnames';
import DisabledContext from 'antd/lib/config-provider/DisabledContext';

import './DatePicker.less';

export const DatePicker = ({
  id,
  name,
  helpText,
  placeholder = 'YYYY-MM-DD',
  value,
  onChange,
  disabled = false,
  // Add additional props that Ant Design Form.Item might pass
  ...restProps
}) => {
  // Track whether a date is selected
  const [isSelected, setIsSelected] = useState(!!value);

  // Format displayed date as yyyy-mm-dd
  const [displayValue, setDisplayValue] = useState('');

  // Update states when value changes
  useEffect(() => {
    setIsSelected(!!value);
    if (value) {
      // Ensure value is displayed in yyyy-mm-dd format
      const formattedDate =
        typeof value === 'string' ? value : value instanceof Date ? value.toISOString().split('T')[0] : '';
      setDisplayValue(formattedDate);
    } else {
      setDisplayValue('');
    }
  }, [value]);

  // Handle date change
  const handleChange = (e) => {
    const newValue = e.target.value;
    setIsSelected(!!newValue);

    // Format for display
    setDisplayValue(newValue);

    // Call the onChange handler with the appropriate event structure for Ant Design
    if (onChange) {
      // Create a synthetic event similar to what Ant Design expects
      const syntheticEvent = {
        target: {
          name,
          value: newValue,
        },
      };
      onChange(syntheticEvent);
    }
  };

  // Check if the form is disabled
  const isFormDisabled = useContext(DisabledContext);
  const isDisabled = disabled || isFormDisabled;

  // Determine wrapper classes based on state
  const wrapperClasses = ['date-field-wrapper', isSelected ? 'date-selected' : '', isDisabled ? 'disabled' : '']
    .filter(Boolean)
    .join(' ');

  return (
    <div
      {...restProps}
      className={classNames(
        wrapperClasses,
        {
          'cursor-not-allowed': isDisabled,
        },
        restProps?.className,
      )}
    >
      <input
        type="date"
        id={id}
        name={name}
        placeholder={placeholder}
        value={displayValue}
        onChange={handleChange}
        disabled={isDisabled}
        min="1800-01-01"
        max="2200-12-31"
      />

      {!isDisabled && (
        <div className="date-field-indicator">
          <Calendar />

          <span className="desktop-text">Click to select</span>
          <span className="mobile-text">Tap to select</span>
        </div>
      )}
    </div>
  );
};
